import { Component } from '@angular/core';
import { ClrVerticalNavModule } from "@clr/angular";
import { RouterLink, RouterLinkActive } from "@angular/router";
import {
  ClarityIcons,
  homeIcon,
  calculatorIcon,
  wrenchIcon,
  infoCircleIcon,
  euroIcon,
  certificateIcon,
  piggyBankIcon,
  employeeGroupIcon, contractIcon, tasksIcon, walletIcon
} from '@cds/core/icon';
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
  selector: 'app-sidenav',
  standalone: true,
    imports: [
        ClrVerticalNavModule,
        RouterLink,
        RouterLinkActive,
        TranslocoDirective
    ],
  templateUrl: './sidenav.component.html',
  styleUrl: './sidenav.component.sass'
})
export class SidenavComponent {
  collapsed: boolean = false;

  constructor() {
      ClarityIcons.addIcons(homeIcon, employeeGroupIcon, contractIcon, calculatorIcon, tasksIcon, wrenchIcon, infoCircleIcon, euroIcon, certificateIcon, piggyBankIcon, walletIcon);
  }

}
